export function formatarValor( valor ){

    let partes = valor.split(".")
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return( partes.join(",") )

}